import { render, staticRenderFns } from "./DrugSearchInput.vue?vue&type=template&id=48981f30&scoped=true&"
import script from "./DrugSearchInput.vue?vue&type=script&lang=js&"
export * from "./DrugSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./DrugSearchInput.vue?vue&type=style&index=0&id=48981f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48981f30",
  null
  
)

export default component.exports